/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `TrendingUpIconProps` interface defines the properties for the TrendingUpIcon component.
 */
interface TrendingUpIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "trending_up" — outlined, weight 300.
 * Upward trend icon for the Wirtschaft (Economy) category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const TrendingUpIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'TrendingUpIcon',
    width
}: TrendingUpIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M132.62-258.08 100-290.69l271.23-271 165.08 165.08L785-643.77H649.54v-45.38H860v210.46h-44.77v-131.85L535.69-330.62 370.62-495.69l-238 237.61Z" />
    </svg>
);

TrendingUpIcon.displayName = 'TrendingUpIcon';